import { api } from "@/api";
import type { Selections } from "@/types/domain";

export const fetchSelections = async (): Promise<Selections> => {
  const response = await api.get<Selections>("/selection/selections");
  return response.data;
};

export const deleteSelection = async (selectionId: string): Promise<void> => {
  await api.post("/selection/delete", { selectionId });
};
